import React from 'react';
import PropTypes from 'prop-types';
import {Filter, PageSection, DateRenderer, RadioButtonQuestion, DatePicker} from "../../../components";
import styled from "styled-components";

const Title = styled.div`
  font-weight: bold;
`;

const StyledPageSection = styled(PageSection)`
  margin: 1em 0 2em 0;
`;

class ReviewDetails extends React.Component {
  // state = {
  //   selectedReviewer: ''
  // };

  // changeReviewer = value => this.setState({selectedReviewer: value}, () =>
  //   this.props.onReviewerChange(value)
  // );

  // componentWillReceiveProps(nextProps) {
  //   if(this.state.selectedReviewer !== nextProps.record.reviewer)
  //     this.setState({selectedReviewer: nextProps.record.reviewer})
  // }

  

  render(){
    const {record, reviewers, form, onChange} = this.props;
    const nonComplianceType = [RadioButtonQuestion.createItem('Regulatory', 'Regulatory'), RadioButtonQuestion.createItem('Technical', 'Technical')];
    // const {selectedReviewer} = this.state;

    return (
      <StyledPageSection title="Review Details">
        <div className="row">
          <div className="col-sm-4">
            <Title className={!form['reviewer'].hasError ? null : 'has-error'}>Reviewer</Title>
            <Filter
              onSelect={onChange('reviewer')}
              items={reviewers}
              title="Select Reviewer"
              filter={form['reviewer'].value}
              renderOption={x => <option key={x.id} value={`${x.firstName} ${x.lastName}`}>{`${x.firstName} ${x.lastName}`}</option>}
              error={!form['reviewer'].hasError ? null : true}
              disabled={form['reviewer'].disabled}
            />
          </div>
          <div className="col-sm-4">
            <Title>Status</Title>
            <div>{record.recordStatus}</div>
          </div>
          <div className="col-sm-4">
            <Title >Review Date</Title>
            <DateRenderer value={record.completeDate}/>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <Title className={!form['compliantSelection'].hasError ? null : 'has-error'}>Compliant?</Title>
            <RadioButtonQuestion
            id="compliantSelection"
            items={RadioButtonQuestion.YesNo}
            value={form['compliantSelection'].value}
            onChange={onChange('compliantSelection')}
            error={!form['compliantSelection'].hasError ? null : true}
            question="Compliant?"
            displayQuestion={false}
            disabled={form['compliantSelection'].disabled}
          />
          </div> 
          <div className="col-sm-4">
            <Title>Date DHS Notified</Title>
            <DatePicker
                value={form['notifiedDate'].value}
                onChange={onChange('notifiedDate')}
                disabled={form['notifiedDate'].disabled}
              />
          </div>
        </div>
        { 
          form['compliantSelection'].value === 'no' &&
          <div className="row">
            <div className="col-sm-4">           
              <RadioButtonQuestion
              id="nonComplianceType"
              items={nonComplianceType}
              value={form['nonComplianceType'].value}
              onChange={onChange('nonComplianceType')}
              error={!form['nonComplianceType'].hasError ? null : true}
              question="Non-Compliance Type"
              displayQuestion={true}
              disabled={form['nonComplianceType'].disabled}
            />
          </div>
        </div>
        }
        
      </StyledPageSection>
    )
  }
}

ReviewDetails.propTypes = {
  record: PropTypes.object.isRequired,
  reviewers: PropTypes.array.isRequired,
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ReviewDetails;



// WEBPACK FOOTER //
// ./src/modules/record/components/ReviewDetails.js